import { getDealsTypes } from '~/utils/experiments'

import { sentenceCase } from './string'

export const decideHeroText = (pageId, locality) => {
  if (locality) {
    return `A new way of exploring broadband speed, deals and issues in in ${sentenceCase(
      locality
    )}! Enter your postcode to get started:`
  }

  return `Enter your postcode to start comparing ${getDealsTypes(pageId)} available to you:`
}
